import { LocalStorageKey } from '@/enums/localStorageKey';
import { useEffect } from 'react';

export function useGenerateUserUUID() {
  function generateUserUUID() {
    if (typeof window === 'undefined') {
      return;
    }

    const uuid = localStorage.getItem(LocalStorageKey.UserUUID);
    if (uuid) {
      return;
    }

    const newUUID = window.crypto.randomUUID();

    localStorage.setItem(LocalStorageKey.UserUUID, newUUID);
  }

  useEffect(generateUserUUID, []);
}
